import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import FormComponent from './js/form.component';
import FormSsoComponent from './js/form-sso.component';

ComponentsFactory.getInstance().define('form', FormComponent);
ComponentsFactory.getInstance().define('form-sso', FormSsoComponent);
